import { render, staticRenderFns } from "./TableOfCosts.vue?vue&type=template&id=6ecc8f46"
import script from "./TableOfCosts.vue?vue&type=script&lang=js"
export * from "./TableOfCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports